import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { settingActions, settingObj } from '../store/SettingSlice';
import { useSelector, useDispatch } from 'react-redux';
import { json, useNavigate } from "react-router-dom";
import * as JSTool from '../store/JSTool';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';

import TitleView from '../component/TitleView';

export default function Page5(props) {

    const [swp, setSwp] = React.useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const settingData = useSelector(state => state.settingData);

    React.useEffect(() => {

    }, []);


    function leftTap() {
        if (swp) {
            swp.slidePrev();
        }
    }

    function rightTap() {
        if (swp) {
            swp.slideNext();
        }
    }

    function indexChanged() {

    }

    return (
        <Stack
            id={props.anchorId}
            sx={{
                width: 1,
                height: settingData.innerHeight,
                alignItems: 'center',
                position: 'relative',
            }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath('bg/bg_5.png')}
                sx={{
                    width: 1,
                    height: settingData.innerHeight,
                    objectFit: 'cover',
                    zIndex: 1,
                    position: 'absolute',
                }} />

            <Stack sx={{
                height: settingData.innerHeight,
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                pt: (!settingData.isMobile && window.innerHeight < 800) && 5,
            }}>

                <TitleView title='Summons' mt={'50rem'} />

                <Box
                    component={'div'}
                    sx={{
                        mt: 3,
                        fontSize: '25rem',
                        color: 'white',
                        fontWeight: 'bold',
                        fontFamily: window.font0,
                        opacity: 0.8,
                        lineHeight: '38rem',
                        textShadow: '2px 2px 6px #26A8E0',
                    }}
                    dangerouslySetInnerHTML={{
                        __html:
                            `
                           Asters are fragments of the heroes' souls in the Mirren history.  <br/>
                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; They can embody the Novas and carry out the Novas' commands.
                           `
                    }} />


                <Stack sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '1000rem',
                    zIndex: 2,
                    flex: 0.8,
                    position: 'relative',
                    mt: '30rem',
                }}>

                    <Swiper style={{
                        width: '100%',
                        padding: 0,
                        margin: 0,
                    }}
                        slidesPerView={7}

                        // modules={[Autoplay]}
                        // loop={true}
                        // autoplay={{
                        //     delay: 3000,
                        //     disableOnInteraction: false,
                        // }}

                        onSlideChangeTransitionEnd={(sp) => {
                            indexChanged();
                        }}

                        onSwiper={(swiper) => {
                            setSwp(swiper);
                            swiper.slideTo(0);
                        }}>

                        {
                            JSTool.RoleAry.map((item, index) => {
                                return <SwiperSlide key={index}><Item item={item} index={index} /></SwiperSlide>
                            })
                        }

                    </Swiper>
                </Stack>

            </Stack>
        </Stack>
    );
}

function Item(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    function itemTap() {
        dispatch(settingActions.setRoleItem(props.item));
        navigate('/role_detail');
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                position: 'relative',
                py: '20rem',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.1)',
                },
            }}>
            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_big.png`)}
                sx={{
                    width: '140rem',
                    mt: props.index % 2 == 1 ? '50rem' : 0,
                    filter: 'drop-shadow(0px 0px 15px #745ff299)',
                }} />

            <Box component={'img'}
                src={JSTool.getImgPath(`stellars/${props.item.name}_icon.png`)}
                sx={{
                    position: 'absolute',
                    width: '40rem',
                    bottom: '45rem',
                    left: '13rem'
                }} />

            <Box
                component={'div'}
                sx={{
                    position: 'absolute',
                    color: 'white',
                    fontSize: '12rem',
                    fontWeight: 'bold',
                    bottom: '60rem',
                    left: '55rem',
                    fontFamily: window.font0,
                    transform: 'skewY(-10deg)',
                }}
                dangerouslySetInnerHTML={{
                    __html:
                        `${JSTool.capitalize(props.item.name)}<br/>${props.item.nick}`,
                }} />

        </Stack>
    );
}
